<template>
  <b-card-code title="Modifier unité enseignement">
    <b-card-text>
      <span>Veuillez modifier les coordonnées du unité enseignement </span>
    </b-card-text>
    <!-- form -->
    <validation-observer
      v-if="unite"
      ref="simpleRules"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Année Univ"
              label-for="Année Univ"
            >
              <validation-provider
                #default="{ errors }"
                name="Année Univ"
                rules="required"
              >
                <b-form-input
                  v-model="unite.academic_year"
                  :state="errors.length > 0 ? false : null"
                  disabled
                  placeholder="Année Univ"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Parcour"
              label-for="Parcour"
            >
              <validation-provider
                #default="{ errors }"
                name="Parcour"
                rules="required"
              >
                <v-select
                  v-model="unite.parcour"
                  :clearable="false"
                  :options="parcours"
                  label="title"
                  placeholder="Parcour"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="unite.semester"
                name="radio-montant"
                value="semester 1"
                class="custom-control-primary"
              >
                Semester 1
              </b-form-radio>
              <b-form-radio
                v-model="unite.semester"
                name="radio-percentage"
                value="semester 2"
                class="custom-control-primary"
              >
                Semester 2
              </b-form-radio>
            </div>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Libellé"
              label-for="Libellé"
            >
              <validation-provider
                #default="{ errors }"
                name="Libellé"
                rules="required"
              >
                <b-form-input
                  v-model="unite.label"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Libellé"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Libellé en Arabe"
              label-for="Libellé en Arabe"
            >
              <validation-provider
                #default="{ errors }"
                name="Libellé en Arabe"
                rules="required"
              >
                <b-form-input
                  v-model="unite.label_arabe"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Libellé en Arabe"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <h5>Active</h5>
              <b-form-checkbox
                v-model="unite.is_active"
                name="check-button"
                switch
                inline
                @click="unite.is_active = true"
              >
                Active
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="unite.type"
                name="radio-f"
                value="fondamentale"
                class="custom-control-primary"
              >
                Fondamentale
              </b-form-radio>
              <b-form-radio
                v-model="unite.type"
                name="radio-t"
                value="transversale"
                class="custom-control-primary"
              >
                Transversale
              </b-form-radio>
              <b-form-radio
                v-model="unite.type"
                name="radio-o"
                value="optionelle"
                class="custom-control-primary"
              >
                Optionelle
              </b-form-radio>
            </div>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Niveau"
              label-for="Niveau"
            >
              <validation-provider
                #default="{ errors }"
                name="Niveau"
                rules="required"
              >
                <b-form-input
                  v-model="unite.level"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Niveau"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Ordre"
              label-for="Ordre"
            >
              <validation-provider
                #default="{ errors }"
                name="Ordre"
                rules="required"
              >
                <b-form-input
                  v-model="unite.ordre"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Ordre"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="editFiliere"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import storeAuth from '@/store/store'

import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BFormRadio,
  BCardText /*  */,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormCheckbox,
    BFormRadio,
  },
  data() {
    return {
      password: '',
      unite: {},
      required,
      categories: ['licence', 'master', 'cycle préparatoire', 'cycle ingénieur'],
      departements: [],
      parcours: [],
    }
  },
  created() {
    this.getParcours()
    this.getDepartements()
    this.getTeachingUnits()
    this.unite.academic_year = storeAuth.state.currentAcademicYear.academic_year
    this.unite.academic_year_id = storeAuth.state.currentAcademicYear.id
  },
  methods: {
    async getParcours() {
      this.load = 'true'
      const response = await axios.get('/api/parcours/')
      this.parcours = response.data
      this.load = 'false'
    },
    async getDepartements() {
      this.load = 'true'
      const response = await axios.get('/api/departments/')
      this.departements = response.data
      this.load = 'false'
    },
    async getTeachingUnits() {
      this.load = 'true'
      const { id } = this.$route.params
      const response = await axios.get(`/api/teaching-units/detail/${id}/`)
      this.unite = response.data
      this.load = 'false'
    },
    async editFiliere() {
      this.$refs.simpleRules.validate().then(async success => {
        const { id } = this.$route.params
        if (success) {
          try {
            await axios
              .put(
                `/api/teaching-units/update/${id}/`,
                {
                  label: this.unite.label,
                  label_arabe: this.unite.label_arabe,
                  parcour: this.unite.parcour.id,
                  type: this.unite.type,
                  ordre: this.unite.ordre,
                  level: this.unite.level,
                  semester: this.unite.semester,
                  is_active: this.unite.is_active,
                },
              )
            this.$router.push('/teaching-units')
            setTimeout(() => {
              this.showToast('success', 'top-center', 'unités d`enseignements Modifié avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
